// React and Next.js imports
import type { GetStaticProps } from "next";

// Builder.io imports

import type { BasePageProps } from "@orlandohealth/build-kit";
import { GenericPage } from "@orlandohealth/build-kit";
import { GenericWrapper } from "@orlandohealth/build-kit";

const Page = GenericPage.createPage(GenericWrapper);

export const getStaticProps: GetStaticProps<BasePageProps> = async ({
  locale,
  defaultLocale,
}) => {
  return GenericPage.getStaticProps("/services", locale, defaultLocale, "page");
};

export default Page;
